import { FilterDocument, FilterOptionKeys, UserSettings } from '@griply/types';

import { pickFilterOptions } from './pick-filter-options';

const upcomingPersistedFilterKeys = [
  FilterOptionKeys.Tag,
  FilterOptionKeys.LifeArea,
  FilterOptionKeys.Goal,
  FilterOptionKeys.GoalActive,
  FilterOptionKeys.GoalImpact,
  FilterOptionKeys.Duration,
  FilterOptionKeys.Priority,
] as const;

// Grouping (fixed) and showCompleted (Show Completed toggle) are not mapped here.
export const mapPartialToUpcomingSettings = (
  partial: Partial<FilterDocument>,
): Partial<UserSettings> | null => {
  const settings: Partial<UserSettings> = {};
  const upcomingFiltersSlot: Partial<FilterDocument> = {};

  if (partial.sortingMode !== undefined) {
    settings.upcoming = { sortingMode: partial.sortingMode ?? undefined };
  }

  if (partial.filters !== undefined) {
    const filters = partial.filters;

    upcomingFiltersSlot.filters =
      filters === null
        ? null
        : pickFilterOptions(filters, upcomingPersistedFilterKeys);
  }

  if (Object.keys(upcomingFiltersSlot).length) {
    settings.filters = { upcoming: upcomingFiltersSlot };
  }

  if (!Object.keys(settings).length) {
    return null;
  }

  return settings;
};
